// extracted by mini-css-extract-plugin
module.exports = {"unorderedList":"styles_unorderedList__YmZWn","listItem":"styles_listItem__1SOjn","bullet":"styles_bullet__2haXY"};